<div class="container-fluid vh-100 background">
    <div class="row text-editor-header">
        <div class="col-md-12 col-lg-12 col-xl-12">
            <text-editor-header></text-editor-header>
        </div>
    </div>
    <div class="row text-editor-body">
        <div class="col-md-12 col-lg-12 col-xl-12">
            <text-editor-body></text-editor-body>
        </div>
    </div>
</div>
     

      
  


